<template>
    <div class="row mb-4">
        <div class="col-3">
            <div class="card text-center pt-2">
                <h6 class="text-uppercase">Totalt antal artiklar</h6>
                <h1>{{ total }}</h1>
            </div>
        </div>

        <div class="col-3">
            <div class="card text-center pt-2">
                <h6 class="text-uppercase">Inväntar godkännande</h6>
                <h1>{{ awaiting_confirmation }}</h1>
            </div>
        </div>

        <div class="col-3">
            <div class="card text-center pt-2">
                <h6 class="text-uppercase">< 10 dagar kvar till deadline</h6>
                <h1>{{ deadline_closing }}</h1>
            </div>
        </div>

        <div class="col-3">
            <div class="card text-center pt-2">
                <h6 class="text-uppercase">Beställningar</h6>
                <h1>{{ placed_orders }}</h1>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

export default {
    components: {
        apexcharts: VueApexCharts
    },
    props : ['company'],
    data() {
        return {
            total : 0,
            awaiting_confirmation: 0,
            deadline_closing: 0,
            placed_orders: 0,
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            const { data } = await axios.get(
                "api/analytics/printables_summary?company_id=" + this.company
            );

            data.map(item => this[item.type] = item.count)
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/PrintableBoxes.vue